import { combineReducers } from '@reduxjs/toolkit';
import vehicleReducer from '../whitelistBlacklistVehicle/vehicles-slice';
import fileReducer from './fileReducer';
import { assetSlice } from '../Assets/asset-slice';
import { systemSlice } from '../SystemDetail/system-detail-slice';
import { authSlice } from '../auth/authSlice';
const rootReducer = combineReducers({
    blacklistWhitelistVehicle: vehicleReducer,
    assetsDetail: assetSlice.reducer,
    systemDetail: systemSlice.reducer,
    authSlice: authSlice.reducer,
    file: fileReducer
});
export default rootReducer;
